import types from '@constants/action-types';
import { actionRequestFactory, actionResponseFactory } from '@factories';

export const getTaxCodesJurisdictionsRequest = payload =>
  actionRequestFactory(types.GET_TAX_CODES_JURISDICTIONS_REQUEST, payload);
export const getTaxCodesJurisdictionsSuccess = response =>
  actionResponseFactory(types.GET_TAX_CODES_JURISDICTIONS_SUCCESS, response);
export const getTaxCodesJurisdictionsFailure = error =>
  actionResponseFactory(types.GET_TAX_CODES_JURISDICTIONS_FAILURE, { error });

export const getTaxCodesRequest = entity =>
  actionRequestFactory(types.GET_TAX_CODES_REQUEST, entity);
export const getTaxCodesSuccess = response =>
  actionResponseFactory(types.GET_TAX_CODES_SUCCESS, response);
export const getTaxCodesFailure = error =>
  actionResponseFactory(types.GET_TAX_CODES_FAILURE, { error });

export const clearClientTransactionTypes = () =>
  actionRequestFactory(types.CLEAR_CLIENT_TRANSACTION_TYPES);

export const saveClientTaxCodes = entity =>
  actionRequestFactory(types.SAVE_CLIENT_TAX_CODES, entity);
export const saveClientTaxCodesSuccess = response =>
  actionResponseFactory(types.SAVE_CLIENT_TAX_CODES_SUCCESS, response);
export const saveClientTaxCodesFailure = error =>
  actionResponseFactory(types.SAVE_CLIENT_TAX_CODES_FAILURE, { error });

export const getTaxCodesRatesRequest = country =>
  actionRequestFactory(types.GET_TAX_CODES_RATES_REQUEST, country);
export const getTaxCodesRatesSuccess = response =>
  actionResponseFactory(types.GET_TAX_CODES_RATES_SUCCESS, response);
export const getTaxCodesRatesFailure = error =>
  actionResponseFactory(types.GET_TAX_CODES_RATES_FAILURE, { error });

export const getClientTransactionTypesRequest = (entityJurisdictionId, entityName) =>
  actionRequestFactory(types.GET_CLIENT_TRANSACTION_TYPES_REQUEST, {
    entityJurisdictionId,
    entityName,
  });
export const getClientTransactionTypesSuccess = response =>
  actionResponseFactory(types.GET_CLIENT_TRANSACTION_TYPES_SUCCESS, response);
export const getClientTransactionTypesFailure = error =>
  actionResponseFactory(types.GET_CLIENT_TRANSACTION_TYPES_FAILURE, { error });
export const resetClientTransactionTypes = vatNumber =>
  actionRequestFactory(types.RESET_CLIENT_TRANSACTION_TYPES, { vatNumber });

export const getContinuousClientTransactionTypesRequest = entityJurisdictionId =>
  actionRequestFactory(types.GET_CONTINUOUS_CLIENT_TRANSACTION_TYPES_REQUEST, entityJurisdictionId);
export const getContinuousClientTransactionTypesSuccess = response =>
  actionResponseFactory(types.GET_CONTINUOUS_CLIENT_TRANSACTION_TYPES_SUCCESS, response);
export const getContinuousClientTransactionTypesFailure = error =>
  actionResponseFactory(types.GET_CONTINUOUS_CLIENT_TRANSACTION_TYPES_FAILURE, { error });

export const saveNewTaxCodeWizardMap = taxCodes =>
  actionRequestFactory(types.SAVE_NEW_TAX_CODE_WIZARD_MAP, taxCodes);

export const getTaxCodesWithTransactionTypesRequest = payload =>
  actionRequestFactory(types.GET_TAX_CODES_WITH_TRANSACTION_TYPES_REQUEST, payload);
export const getTaxCodesWithTransactionTypesSuccess = response =>
  actionResponseFactory(types.GET_TAX_CODES_WITH_TRANSACTION_TYPES_SUCCESS, response);
export const getTaxCodesWithTransactionTypesFailure = error =>
  actionResponseFactory(types.GET_TAX_CODES_WITH_TRANSACTION_TYPES_FAILURE, { error });
export const resetTaxCodesWithTransactionTypes = () =>
  actionResponseFactory(types.RESET_TAX_CODES_WITH_TRANSACTION_TYPES, null);

export const updateTaxCodesSearchQuery = searchQuery =>
  actionRequestFactory(types.UPDATE_TAX_CODES_SEARCH_QUERY, searchQuery);
export const clearTaxCodesSearchQuery = () =>
  actionRequestFactory(types.CLEAR_TAX_CODES_SEARCH_QUERY, null);
